// extracted by mini-css-extract-plugin
export default {"scubeInfo":"scubeInfo_scubeInfo__W4kFq","img-box":"scubeInfo_img-box__vx6Sn","scubeInfo__list":"scubeInfo_scubeInfo__list__kLPah"};